
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PlaneTakeoff, Train, Car, Ship, Bus } from 'lucide-react';

interface TransportTypePickerProps {
  selectedType: string;
  onChange: (value: string) => void;
}

export const transportationTypes = [
  { value: 'flight', label: 'Flight', icon: <PlaneTakeoff className="h-4 w-4 mr-2" /> },
  { value: 'train', label: 'Train', icon: <Train className="h-4 w-4 mr-2" /> },
  { value: 'car', label: 'Car', icon: <Car className="h-4 w-4 mr-2" /> },
  { value: 'ferry', label: 'Ferry/Ship', icon: <Ship className="h-4 w-4 mr-2" /> },
  { value: 'shuttle', label: 'Shuttle', icon: <Bus className="h-4 w-4 mr-2" /> }
];

const TransportTypePicker: React.FC<TransportTypePickerProps> = ({ selectedType, onChange }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="transport-type">Transportation Type</Label>
      <Select 
        value={selectedType} 
        onValueChange={onChange}
      >
        <SelectTrigger id="transport-type">
          <SelectValue placeholder="Select transportation" />
        </SelectTrigger>
        <SelectContent>
          {transportationTypes.map(type => (
            <SelectItem key={type.value} value={type.value}>
              <div className="flex items-center">
                {type.icon}
                {type.label}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default TransportTypePicker;
